import { render, staticRenderFns } from "./CourseCategoryCourses.vue?vue&type=template&id=aa8b00b8&scoped=true"
import script from "./CourseCategoryCourses.vue?vue&type=script&lang=js"
export * from "./CourseCategoryCourses.vue?vue&type=script&lang=js"
import style0 from "./CourseCategoryCourses.vue?vue&type=style&index=0&id=aa8b00b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8b00b8",
  null
  
)

export default component.exports